/**
 * External Dependencies
 */
import $ from 'jquery'

setInterval(() => {
  const hasModalClass = document.querySelector('body.htr-modal-prevent-scroll')
  const hasScrolledClass = document.querySelector('.site-header.scrolled')

  if (hasModalClass && !hasScrolledClass) {
    document.querySelector('.site-header').classList.add('scrolled')
  }
}, 1000)

function enableScroll () {
  document.body.classList.remove('overflow-hidden')
}

function disableScroll () {
  document.body.classList.add('overflow-hidden')
}

function bindWpSwiper () {
  const domSwiper = document.querySelector('.home .swiper-wp .swiper-container')
  if (!domSwiper) {
    return
  }

  const swiperInstance = domSwiper.swiper
  if (!swiperInstance) return

  swiperInstance.on('slideChange', function (swiper) {
    const currentSlideDOM = document.querySelector(
      '.home .swiper-wp .currentSlide'
    )

    currentSlideDOM.innerHTML = swiper.realIndex + 1
  })
}

function handleMenuImageSwiper () {
  document.querySelectorAll('[data-image]').forEach(function (menuItem) {
    menuItem.querySelector('a').addEventListener('mouseout', function () {
      const targetImageWrapper = menuItem.parentNode.parentNode.parentNode.querySelector(
        '[data-target-image]'
      )

      const image = targetImageWrapper.querySelector('img')

      targetImageWrapper.removeChild(image)
    })

    menuItem.querySelector('a').addEventListener('mouseover', function () {
      const imageURL = menuItem.getAttribute('data-image')

      if (!imageURL) return

      const targetImageWrapper = menuItem.parentNode.parentNode.parentNode.querySelector(
        '[data-target-image]'
      )

      const image = new Image()
      image.classList.add('opacity-0')
      image.classList.add('transitions-all')
      image.classList.add('duration-500')

      image.src = imageURL
      targetImageWrapper.appendChild(image)
      image.onload = () => {
        image.classList.remove('opacity-0')
      }
    })
  })
}

$(() => {
  bindWpSwiper()
  handleMenuImageSwiper()

  // Header
  const header = document.querySelector('.site-header')
  const headerHeight = header.offsetHeight
  const headerSearchIcon = header.querySelectorAll(
    '.site-header__search svg path'
  )
  const headerSearchButtonContent = header.querySelector(
    '.site-header__search #site-header__search-btn'
  )
  const headerMenuIcon = header.querySelectorAll(
    '.site-header__menu-offcanvas svg path'
  )
  const headerMenuButtonContent = header.querySelector(
    '.site-header__menu-offcanvas #site-header__menu-offcavas-btn'
  )
  const megaMenuSubMenuParent = document.querySelectorAll(
    '.menu-item-has-children'
  )
  const megaMenuSubMenu = document.querySelectorAll('.sub-menu--wrapper')

  bodyPadding()
  // even if resized
  document.addEventListener('resize', bodyPadding())

  function bodyPadding () {
    document.body.style.paddingTop = headerHeight + 'px'
  }

  // set sub menu height
  setSubMenuHeight()
  // even if resized
  document.addEventListener('resize', setSubMenuHeight())

  function setSubMenuHeight () {
    megaMenuSubMenu.forEach(el => {
      el.style.top = headerHeight + 'px'
    })
  }

  if (megaMenuSubMenuParent) {
    megaMenuSubMenuParent.forEach(el => {
      el.addEventListener('mouseenter', function () {
        disableScroll()

        header.classList.add('bg-gray')
        header.is_open = true

        if (el.classList.contains('layout-2')) {
          headerSearchIcon.forEach(el => {
            el.style.fill = '#fff'
          })
          headerMenuIcon.forEach(el => {
            el.style.fill = '#fff'
          })
          headerMenuButtonContent.style.color = '#fff'
          headerSearchButtonContent.style.color = '#fff'
        }
      })

      el.addEventListener('mouseleave', function () {
        enableScroll()
        header.is_open = false
        header.classList.remove('bg-gray')
        if (el.classList.contains('layout-2')) {
          headerSearchIcon.forEach(el => {
            el.style.fill = 'var(--wp--preset--color--black)'
          })
          headerMenuIcon.forEach(el => {
            el.style.fill = 'var(--wp--preset--color--black)'
          })
          headerMenuButtonContent.style.color =
            'var(--wp--preset--color--black)'
          headerSearchButtonContent.style.color =
            'var(--wp--preset--color--black)'
        }
      })
    })
  }

  // header scrolling down on scroll / swipe up
  const sensibleScrollArea = header.offsetHeight * 2
  let lastScroll = 0

  window.addEventListener('scroll', function (e) {
    if (header.is_open) {
      header.classList.remove('scrolled')
      return
    }

    const windowOffsetY = window.pageYOffset || document.documentElement.scrollTop
    if (windowOffsetY > lastScroll && windowOffsetY > sensibleScrollArea) {
      header.classList.add('scrolled')
    } else {
      header.classList.remove('scrolled')
    }
    lastScroll = windowOffsetY <= 0 ? 0 : windowOffsetY
    e.preventDefault()
  })

  // Off Canvas Menu
  const offCanvasBtn = document.getElementById('site-header__menu-offcavas-btn')
  const offCanvasMenu = document.getElementById('menu-offcanvas')
  const offCanvasCloseBtn = document.getElementById(
    'menu-offcanvas__menu-offcavas-btn'
  )
  const offCanvasContent = offCanvasMenu.querySelector(
    '.menu-offcanvas__content'
  )

  document.addEventListener('click', function (e) {
    if (
      (e.target != offCanvasContent && !offCanvasContent.contains(e.target)) ||
      e.target == offCanvasCloseBtn
    ) {
      if (offCanvasMenu.classList.contains('open')) {
        offCanvasMenu.classList.remove('open')
        enableScroll()
      }
    }
  })

  offCanvasBtn.addEventListener('click', function (e) {
    offCanvasMenu.classList.toggle('open')
    disableScroll()

    e.stopPropagation()
  })

  // Wrapping video blocks with mediaelement.js
  const videoBlockSelectors = document.querySelectorAll('.wp-block-video video')
  videoBlockSelectors.forEach(video => {
    $(video).attr('playsinline', '')
    const player = new MediaElementPlayer(video, {
      videoWidth: '100%',
      videoHeight: 'auto',
      success: function (mediaElement) {
        mediaElement.addEventListener(
          'playing',
          function (e) {
            // console.log('video play')
          },
          false
        )
        mediaElement.addEventListener('canplay', function () {
          mediaElement.play()
        })
      }
    })
  })

  const modalBlockContent = document.querySelectorAll('.htr-modal-content')

  if (modalBlockContent) {
    modalBlockContent.forEach(modal => {
      const closeBtn = modal.children[1]
      const contentWrapper = modal.children[2]

      contentWrapper.append(closeBtn)

      closeBtn.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="28.284" height="28.284" viewBox="0 0 28.284 28.284"><g transform="translate(-1762.858 -23.358)"><path d="M36,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H36a1,1,0,0,1,1,1A1,1,0,0,1,36,1Z" transform="translate(1764.272 24.772) rotate(45)" fill="currentColor"></path><path d="M36,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H36a1,1,0,0,1,1,1A1,1,0,0,1,36,1Z" transform="translate(1789.728 24.772) rotate(135)" fill="currentColor"></path></g></svg> Chiudi'
    })
  }

  // Fix parent column height for full card styles
  const fullHeightCard = document.querySelectorAll('.is-style-full-card')

  fullHeightCard.forEach(card => {
    const parentColumn = card.parentNode
    parentColumn.style.height = '100%'
  })

  // Search on Header Menu
  const searchHeader = document.getElementById('site-header__search-btn')
  searchHeader.addEventListener('click', function (e) {
    e.preventDefault()
    searchModal()
  })

  // Search on Offcanvas Menu
  const searchOffcanvas = document.getElementById('menu-offcanvas__search-btn')
  searchOffcanvas.addEventListener('click', function (e) {
    e.preventDefault()
    searchModal()
  })

  const closeSearchModal = document.getElementById('search-modal__close-btn')
  closeSearchModal.addEventListener('click', function (e) {
    e.preventDefault()
    const modal = document.getElementById('search-modal')
    modal.classList.remove('is-open')
    document.body.style.overflowY = 'auto'
  })

  function searchModal () {
    const modal = document.getElementById('search-modal')
    modal.classList.toggle('is-open')

    if (modal.classList.contains('is-open')) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflowY = 'auto'
    }
  }

  // MailUP language
  const mailUpFields = document.getElementById('mupwp-form-fields')
  if (mailUpFields) {
    let lang = 'it'
    const pathArray = document.location.pathname.split('/').filter(Boolean)
    if (pathArray.includes('en')) {
      lang = 'en'
    } else {
      lang = 'it'
    }
    const mailUpField = Array.from(
      mailUpFields.querySelectorAll('.mupwp-form-field:last-of-type')
    )
    const langInput = mailUpField[0].querySelector("input[type='text']")
    if (langInput) {
      langInput.value = lang
    }
  }

  // Gutenslider
  const gutensliderContainers = document.querySelectorAll(
    '.wp-block-eedee-block-gutenslider'
  )

  if (gutensliderContainers) {
    gutensliderContainers.forEach(gutenslider => {
      const sliderSwiper = gutenslider.querySelector('.eedee-swiper-outer')
      const sliderWrapper = sliderSwiper.querySelector('.swiper-wrapper')
      const prevArrow = sliderSwiper.querySelector('.eedee-gutenslider-prev')
      const nextArrow = sliderSwiper.querySelector('.eedee-gutenslider-next')
      const slides = sliderWrapper.querySelectorAll('.swiper-slide')
      const sliderPagination = gutenslider.querySelector(
        '.eedee-gutenslider-pagination'
      )
      const currentSlideNumber = document.createElement('div')
      const totalSlideNumber = document.createElement('div')

      sliderPagination.appendChild(currentSlideNumber)
      sliderPagination.appendChild(totalSlideNumber)

      currentSlideNumber.classList.add('currentSlide')
      totalSlideNumber.classList.add('totalSlide')

      const currentSlideVal = '1'

      currentSlideNumber.innerHTML = currentSlideVal
      totalSlideNumber.innerHTML = slides.length - 2 // swiper adds 2 duplicate slides
    })
  }
})
